export interface GameRequestUser {
  id: string;
  username: string;
  avatar_url: string | null;
  is_admin: boolean;
}

export type GameRequestType = 'new_game' | 'update_request';

export interface GameRequestSummary {
  id: number;
  request_type: GameRequestType;
  game_name: string;
  steam_link: string | null;
  steam_appid: number | null;
  steam_image_url: string | null;
  image_url: string | null;
  other_link: string | null;
  platforms: string[];
  version: string | null;
  votes_count: number;
  voted: boolean;
  comments_count: number;
  completed: boolean;
  completed_at: string | null;
  game: { id: number; name: string; path: string } | null;
  created_at: string;
  user: GameRequestUser | null;
}

export interface GameRequestComment {
  id: number;
  content_html: string;
  created_at: string;
  edited: boolean;
  user: GameRequestUser;
  can_edit: boolean;
  quoted: { id: number; username: string; text: string } | null;
}

export interface GameRequestDetail extends GameRequestSummary {
  description_html: string;
  steam_name: string | null;
  comments: GameRequestComment[];
}

export interface SteamLookupResult {
  appid: number;
  name: string;
  image_url: string | null;
}

export interface DuplicateGameInfo {
  id: number;
  name: string;
  path: string;
}

export interface DuplicateRequestInfo {
  id: number;
  game_name: string;
  path: string;
}

export interface DuplicateCheckResult {
  game: DuplicateGameInfo | null;
  request: DuplicateRequestInfo | null;
}

export const STEAM_APP_URL_PATTERN = /^https:\/\/store\.steampowered\.com\/app\/\d+/;

export const GAME_REQUEST_DEFAULT_PLATFORMS = [
  'Steam',
  'GOG',
  'Epic Games',
  'Egyéb',

];
export const GAME_REQUEST_PLATFORM_MAX_COUNT = 10;
export const GAME_REQUEST_PLATFORM_MAX_LENGTH = 40;
export const GAME_REQUEST_VERSION_MAX_LENGTH = 100;

export const GAME_REQUEST_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
export const GAME_REQUEST_IMAGE_MAX_SIZE = 5 * 1024 * 1024;

const escapeHtml = (value: string): string =>
  value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

export const getDefaultRequestDescription = (requesterName: string): string => {
  const signature = requesterName.trim() ? `<p>${escapeHtml(requesterName.trim())}</p>` : '';
  return `<p>Kedves fordítók! Nagyon szeretném, ha ránéznétek erre a játékra. Köszönöm!</p>`;
};

export const getDefaultUpdateRequestDescription = (requesterName: string): string => {
  const signature = requesterName.trim() ? `<p>${escapeHtml(requesterName.trim())}</p>` : '';
  return `<p>Kedves fordítók! Ehhez a játékhoz új verzió jelent meg, nagyon szeretném, ha ránéznétek. Köszönöm!</p>${signature}`;
};

export const getCsrfToken = (): string =>
  (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement | null)?.content ?? '';

export const formatGameRequestDate = (iso: string): string =>
  new Date(iso).toLocaleString('hu-HU', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

export const extractErrorMessage = async (response: Response, fallback: string): Promise<string> => {
  try {
    const data = await response.json();
    if (Array.isArray(data?.errors)) return data.errors.join(', ');
    if (typeof data?.error === 'string') return data.error;
  } catch {
    // Nem JSON válasz: alapértelmezett üzenet
  }
  return fallback;
};
